import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../api.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from 'rxjs';
import { AuthenticationService } from "../../firebase/authentication.service";
import { ChatService } from "../../services/chat.service";
import { FunctionsService } from "../../services/functions.service";
import { SignalRService } from "../../services/signalr.service";
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ViewAlertComponent } from './view-alert/view-alert.component';
import { Router, RouterOutlet } from '@angular/router';
import { AppConstants } from 'src/app/app.constants';
import { NgxPermissionsService } from 'ngx-permissions';
import { AgmMap } from '@agm/core';
import { AlertService } from 'src/app/services/alert.service';
import { PaginationModel } from 'src/app/models/paginationModel';

var map2;

@Component({
    selector: 'alert-component',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    providers: [NgxSpinnerService]
})

export class AlertComponent implements OnInit {
    
    user: Observable<firebase.default.User>;
    items: Observable<any[]>;
    alertDate: any;
    alertNotified: any;
    alertStatusNotified: any;
    statusNotified: any;
    @ViewChild(RouterOutlet, {static: true}) outlet: RouterOutlet;
    @ViewChild('AgmMap', {static: true}) agmMap: AgmMap;

    constructor(
        public signalRService: SignalRService,
        private apiService: ApiService,
        private spinner: NgxSpinnerService,
        public authenticationService: AuthenticationService,
        public chatService: ChatService,
        private translate: TranslateService,
        private modalService: NgbModal,
        public router: Router,
        public functionsService: FunctionsService,
        public permission: NgxPermissionsService,
        private pagination: PaginationModel,
        public alertService: AlertService) {
        this.alertDate = functionsService;
        this.fetchAlertTypes();
        this.getAgents();
        this.fetchAlertZones();
    }

    agentDispatch: any;
    geoZoneAssignment: any;
    statusTypes: string[];
    pageSize = 50;
    active = "CreatedDate";
    falseRealAlert = 5;
    atFilter = "-";
    icon = AppConstants.icons;
    infoWindowOpened = null
    previous_info_window = null
    loading: boolean = true;

    title: string = 'Alert Map';
    zoom: number = 16;
    notified: boolean = false;
    orgId: any;
    timer:any;
    lat = 18.3939867;
    lng  = -66.1052846;
    lateTimer: any; 
    clock: any;

    close_window() {
        if (this.previous_info_window != null) {
            this.previous_info_window.close()
        }
    }

    select_marker(data) {
        if (this.previous_info_window == null) {
            this.previous_info_window = data;
        }
        else {
            this.infoWindowOpened = data
            this.previous_info_window.close()
        }
        this.previous_info_window = data;
    }

    mapReady(map) {
        setTimeout(() => {
            this.spinner.hide();
        }, 5000);
        
        map2 = map;
        
        google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
            this.timer = setInterval( ()=> {
                if(this.alertService.alerts && this.alertService.alerts.length!=0){
                    const bounds = new google.maps.LatLngBounds();
                    for (const marker of this.alertService.alerts) {
                        if(marker.initialLatitude && marker.initialLongitude){
                            bounds.extend(new google.maps.LatLng(+marker.initialLatitude, +marker.initialLongitude));
                        }
                    }
                    map2.fitBounds(bounds);
                    this.stopInterval();
                }
            }, 1000);
            this.spinner.hide();
        });
    }

    async ngOnInit() {
        this.spinner.show();
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
        this.translate.onLangChange.subscribe(() => {
            if(document.getElementsByClassName("mat-paginator-page-size-label")){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page"); 
            }
        });
        this.statusTypes = ["Attending", "Canceled", "Unattended"];
        this.functionsService.setTitle('alert.active_alerts');
        this.alertService.agentFilter = "general.select_agent";
        this.alertService.alertTypeFilter = "select_alert_type";
        this.alertService.zoneFilter = "alert.select_geo_zone"
        this.alertService.statusFilter = "alert.unattended";
        this.alertService.statusToDisplay = "alert.unattended";
        this.alertService.outZoneFilter = "alert.select-out-of-zone";
        this.alertService.lateFilter = "alert.select-late";
        this.alertService.filtersApplied = [];
        this.alertService.selectedOrder = "Ascending";
        this.alertService.page = 0;
        this.pagination.Order = "ASC";
        this.pagination.AgentId = 0;
        this.pagination.ZoneId = 0;
        this.pagination.OutOfZone = "alert.select-out-of-zone";
        this.pagination.Late = "alert.select-late";
        this.pagination.Status = 1;
        this.clock = setInterval(()=>{
            const d = new Date();
            this.lateTimer = d.getTime();
        }, 1000)
        this.changeStatusFilterLabel("alert.unattended");
        this.applyFilter();
        var role = await this.functionsService.getRole();
        var expired = false;
        this.permission.hasPermission("Expired").then( response => {
            if((response) && (expired!=null)){
                expired = true; 
                if((localStorage.getItem("isBroadcastRegistered") == "true")){
                    localStorage.setItem("signOut", "2");
                    this.signalRService.connection.stop();
                }
            }   
        });
        if (role == "Activate") {
            this.router.navigateByUrl('/main/account');
        }
        this.spinner.hide();
    }

    verifyUnattendedLate(alert){
        if(alert.status == 3){
            var attendTime = alert.attendTime ? alert.attendTime : "00:00";
            var times = attendTime.split(':');
            var milliseconds = times[0] * 3600000 + times[1] * 60000;
            return new Date(alert.canceledDate).getTime() > (new Date(alert.createdDate).getTime() + milliseconds);
        }
    }

    getDispatchGeo(){
        this.agentDispatch = JSON.parse(localStorage.getItem('agentDispatch'));
        this.geoZoneAssignment = JSON.parse(localStorage.getItem('geoAssignment'));
    }

    fetchAlertZones(){
        this.apiService.getAlertZones().subscribe(
            data => {
                this.alertService.alertZones = data;
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    fetchAlertTypes(){
        this.apiService.getOpenClosedAlertTypes(0).subscribe(
            data => {
                this.alertService.alertTypes = data;
                this.alertService.alertTypes.length > 0 ? this.alertService.alertTypeDisabled = false: this.alertService.alertTypeDisabled = true; 
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    getAgents() {
        this.apiService.getAgents().subscribe(
            data => {
                this.alertService.agents = data;
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }
  
    getAlerts() {
        this.spinner.show();
        this.notified = false;
        this.pagination.Page = this.alertService.page;
        this.pagination.PageSize = this.pageSize;
        this.pagination.OrderBy = this.active;
        this.pagination.AlertType = this.atFilter;
        this.pagination.FalseAlert = this.falseRealAlert;
        this.apiService.getAlerts(this.pagination).subscribe(data => {
                this.alertService.alerts = Object.values(data)[0];
                if(parseInt(Object.keys(data)[0]) == 0){
                    this.currentLocation();
                }else{
                    this.recenter_map(this.alertService.alerts[0]['initialLatitude'], this.alertService.alerts[0]['initialLongitude']);
                }
                this.alertService.totalLength = parseInt(Object.keys(data)[0]);
                const paginatorLabel = document.getElementsByClassName("mat-paginator-page-size-label")[0];
                if(paginatorLabel){
                    document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page"); 
                    this.translate.onLangChange.subscribe(() => {
                        document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                    });
            }
            this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    viewAlert(alertInfo) {
        this.spinner.show();
        this.apiService.getAlert(alertInfo.id).subscribe(
            data => {
                if (data["status"] == 1) { 
                    this.getAlerts();
                    return;
                }
                const modalRef = this.modalService.open(ViewAlertComponent, { scrollable: true, size: 'xl' });
                modalRef.componentInstance.viewAlert(data);
                modalRef.result.then(() => {
                    this.getAlerts();
                    this.fetchAlertTypes();
                });
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    identify(index, alert){
        return alert.Id;
    }

    currentLocation(){
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.callback, () => {
                // this.handleLocationError(true, this.infoWindow, this.map.getCenter());
            });
            this.spinner.hide();
        } 
    }

    callback(position){
        var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        }
        position = new google.maps.LatLng(Number.parseFloat(pos.lat),
        Number.parseFloat(pos.lng));
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(position);            
        map2.fitBounds(bounds);
        map2.panTo(position);
    }

    stopInterval(){
        clearInterval(this.timer);
    }

    recenter_map(latitude, longitude) {
        const position = new google.maps.LatLng(Number.parseFloat(latitude),
            Number.parseFloat(longitude));
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(position);           
        map2.fitBounds(bounds);
        map2.panTo(position);
    }
    
    sortAscending(refresh) {
        this.alertService.selectedOrder = "Ascending";
        this.pagination.Order = "ASC";
        if(refresh){this.getAlerts();}
    }
    sortDescending() {
        this.alertService.selectedOrder = "Descending";
        this.pagination.Order = "DESC";
        this.getAlerts();
    }

    nextPage(evt){
        this.alertService.page = evt.pageIndex;
        this.pageSize = evt.pageSize;
        this.getAlerts();
    }

    changeAgentFilterLabel(agent: string, id: number) {
        this.alertService.agentFilter = agent;
        this.alertService.agentId = id;
        this.pagination.AgentId = id;
    }

    changeZoneFilterLabel(zone: string, id: number) {
        this.alertService.zoneFilter = zone;
        this.alertService.zoneId = id;
        this.pagination.ZoneId = id;
    }

    changeOutZoneFilterLabel(input: string) {
        this.alertService.outZoneFilter = input;
        this.alertService.zoneId = 0;
        this.pagination.ZoneId = 0;
        if(input == "alert.out_of_zone"){
            this.pagination.OutOfZone = "true";
        } else if (input == "alert.not-out-of-zone") {
            this.pagination.OutOfZone = "false";
        }
    }

    changeLateZoneFilterLabel(input: string) {
        this.alertService.lateFilter = input;
        if(input == "alert.late"){
            this.pagination.Late = "true";
        } else if (input == "alert.not-late") {
            this.pagination.Late = "false";
        }
    }

    changeAlertFilterLabel(typeOfAlert: string) {
        this.alertService.alertTypeFilter = typeOfAlert;
        this.atFilter = typeOfAlert;
    }

    changeStatusFilterLabel(status: string) {
        switch(status){
            case 'alert.attending':
                status = "2";
                this.alertService.statusToDisplay = "alert.attending";
                this.pagination.Status = parseInt(status);
                break;
            case 'alert.canceled':
                status = "3";
                this.alertService.statusToDisplay = "alert.canceled";
                this.pagination.Status = parseInt(status);
                break;
            case 'alert.out_of_zone':
                status = "5";
                this.alertService.statusToDisplay = "alert.out_of_zone";
                this.pagination.Status = parseInt(status);
                break;
            case 'alert.unattended':
                status = "0";
                this.alertService.statusToDisplay = "alert.unattended";
                this.pagination.Status = parseInt(status);
                break;
            default:
                status = "alert.select_status";
                this.alertService.statusToDisplay = "alert.select_status";
                this.pagination.Status = 1;
                break;
        }
        this.alertService.statusFilter = status;
    }

    orderOptions: string[] = ["Ascending", "Descending"];
    changeOrder() {
        if(this.alertService.selectedOrder == "Descending"){
            this.sortAscending(true);
        }else if(this.alertService.selectedOrder == "Ascending"){
            this.sortDescending();
        }
    }

    applyFilter() {
        this.spinner.show();
        this.alertService.page = 0;
        this.sortAscending(false);
        this.saveFiltersApplied();
        this.getAlerts();
    }

    saveFiltersApplied(){
        this.alertService.filtersApplied = [];
        if(this.alertService.zoneFilter != "alert.select_geo_zone"){
            this.alertService.filtersApplied.push(this.alertService.zoneFilter);
        }
        if(this.alertService.agentFilter != "general.select_agent"){
            this.alertService.filtersApplied.push(this.alertService.agentFilter);
        }
        if(this.alertService.alertTypeFilter != "select_alert_type"){
            this.alertService.filtersApplied.push(this.alertService.alertTypeFilter);
        }
        if(this.alertService.statusFilter != "alert.select_status"){
            switch(this.alertService.statusFilter){
                case "2":
                    status = "alert.attending";
                    break;
                case "3":
                    status = "alert.canceled";
                    break;
                case "5":
                    status = "alert.out_of_zone";
                    break;
                case "7":
                    status = "alert.unattended";
                    break;
                case "0":
                    status = "alert.unattended";
                    break;
                default:
                    status = "alert.select_status";
                    break;
            }
            this.alertService.filtersApplied.push(status);
        }
        if(this.alertService.outZoneFilter != "alert.select-out-of-zone"){
            this.alertService.filtersApplied.push(this.alertService.outZoneFilter);
        }
        if(this.alertService.lateFilter != "alert.select-late"){
            this.alertService.filtersApplied.push(this.alertService.lateFilter);
        }
    }

    removeFilter(filter){
        this.spinner.show();
        switch(filter){
            case "alert.attending":
                filter = "2";
                break;
            case "alert.canceled":
                filter = "3";
                break;
            case "alert.unattended":
                filter = this.agentDispatch ? "7": "0";
                break;
            case "alert.select_status":
                filter = "";
                break;
            default:
                filter;
                break;
        }
        if(filter == this.alertService.agentFilter){
            this.alertService.agentFilter = "general.select_agent";
            this.pagination.AgentId = 0;
        }else if(filter == this.alertService.zoneFilter){
            this.alertService.zoneFilter = "alert.select_geo_zone";
            this.pagination.ZoneId = 0;
            this.alertService.zoneId = 0;
        }else if(filter == this.alertService.alertTypeFilter){
            this.alertService.alertTypeFilter = "select_alert_type";
            this.atFilter = "-";
        }else if(filter == this.alertService.statusFilter){
            this.alertService.statusFilter = "alert.select_status";
            this.alertService.statusToDisplay = "alert.select_status";
            this.pagination.Status = 1;
        } else if (filter == this.alertService.outZoneFilter) {
            this.alertService.outZoneFilter = "alert.select-out-of-zone";
            this.pagination.OutOfZone = "alert.select-out-of-zone";
        } else if (filter == this.alertService.lateFilter) {
            this.alertService.lateFilter = "alert.select-late";
            this.pagination.Late= "alert.select-late";
        }
        this.applyFilter();
    }

    clearFilter(main?) {
        if(main){
            this.fetchAlertTypes();
            this.getAgents();
            this.fetchAlertZones();
            this.getDispatchGeo();
        }
        this.alertService.agentFilter = "general.select_agent";
        this.pagination.AgentId = 0;
        this.alertService.zoneFilter = "alert.select_geo_zone";
        this.pagination.ZoneId = 0;
        this.alertService.outZoneFilter = "alert.select-out-of-zone";
        this.alertService.lateFilter = "alert.select-late";
        this.pagination.OutOfZone = "alert.select-out-of-zone";
        this.pagination.Late = "alert.select-late";
        this.alertService.alertTypeFilter = "select_alert_type";
        this.atFilter = "-";
        this.alertService.statusFilter = "alert.select_status";
        this.pagination.Status = 1;
        this.alertService.page = 0;
        this.alertService.statusToDisplay = "alert.select_status";
        this.sortAscending(false);
        this.alertService.filtersApplied = [];
        this.getAlerts();
    }

}